/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface GetInstallerLicense200Response
 */
export interface GetInstallerLicense200Response {
    /**
     * Full Stripe subscription status. The collector uses this to decide whether to start collecting.
     */
    subscriptionStatus?: string;
    /**
     * Client operating mode: `monitoring` (continuous scanning) or `audit` (one-shot assessment).
     */
    mode?: string;
    /**
     * Milliseconds the collector should wait before retrying when the subscription is not active.
     */
    sleepForMs?: number;
}

/**
 * Check if a given object implements the GetInstallerLicense200Response interface.
 */
export function instanceOfGetInstallerLicense200Response(value: object): value is GetInstallerLicense200Response {
    return true;
}

export function GetInstallerLicense200ResponseFromJSON(json: any): GetInstallerLicense200Response {
    return GetInstallerLicense200ResponseFromJSONTyped(json, false);
}

export function GetInstallerLicense200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInstallerLicense200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'subscriptionStatus': json['subscriptionStatus'] == null ? undefined : json['subscriptionStatus'],
        'mode': json['mode'] == null ? undefined : json['mode'],
        'sleepForMs': json['sleepForMs'] == null ? undefined : json['sleepForMs'],
    };
}

export function GetInstallerLicense200ResponseToJSON(json: any): GetInstallerLicense200Response {
    return GetInstallerLicense200ResponseToJSONTyped(json, false);
}

export function GetInstallerLicense200ResponseToJSONTyped(value?: GetInstallerLicense200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subscriptionStatus': value['subscriptionStatus'],
        'mode': value['mode'],
        'sleepForMs': value['sleepForMs'],
    };
}

